import React, { SVGProps } from "react";

const PlusSmIcon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element = ({
  height = "24px",
  width = "24px",
  stroke = "currentColor",
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 6V12M12 12V18M12 12H18M12 12L6 12"
        stroke={stroke}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusSmIcon;
